import axios from "axios"

export default function api() {}

api.connectOffline = async (user, pass) => {
  if (user === "fi-remote" && pass === "(KiWi)mgu[369]remote") return {token: "success", name: "remote", owner: "FI", _id: "1"}
  console.log("check failed")
  return false
}


api.connect = async (user, pass) => {
  console.log("api connecting login", { uname: user, passw: pass }, window.fmsApiLink)
  return await axios.create({ baseURL: window.fmsApiLink }).post("users/login", { uname: user, passw: pass })
}
/*
api.connect = async (user, pass) => {
  return await api.call.post("users/login", { uname: user, passw: pass })
}*/

api.authCheck = async () => {
  const apiToken = localStorage.getItem('apiToken')
  return await axios.create({ baseURL: window.fmsApiLink }).get('users/me', { headers: { "Authorization" : `Bearer ${apiToken}` }})
}

api.generateSonaeMission = async (data) => { // expects: { robotId: "our-robot-id", orderCode: "sonae-order-code"}
  const apiToken = localStorage.getItem('apiToken')
  // console.log("api calling", data)
  return await axios.create({ baseURL: window.fmsApiLink }).post("circuit/run", data, {
    headers: { Authorization: `Bearer ${apiToken}` },
  })
}

api.saveCircuit = async (circuit) => {
  const apiToken = localStorage.getItem('apiToken')
  // console.log("api token", apiToken)
  return await axios.create({ baseURL: window.fmsApiLink }).post("circuit/new", circuit, {
    headers: { Authorization: `Bearer ${apiToken}` },
  })
}

api.saveMap = async (map) => {
  const apiToken = localStorage.getItem('apiToken')
  // console.log("api save map", map, id)
    return await axios.create({ baseURL: window.fmsApiLink }).post("map/new", map, {
      headers: { Authorization: `Bearer ${apiToken}` },
    })
}

/*
api.createMap = async map => {
  const apiToken = localStorage.getItem('apiToken')
  console.log("creating map", map, window.settings.fmsIp)
  const res = await axios.create({ baseURL: window.fmsApiLink }).post('map/new', map, { headers: { Authorization: `Bearer ${apiToken}`, } })
  return res
}*/

api.sendTrigger = async (trigger) => {
  const apiToken = localStorage.getItem('apiToken')
  // console.log("api save map", map, id)
  return await axios.create({ baseURL: window.fmsApiLink }).post("triggers/new", trigger, {
    headers: { Authorization: `Bearer ${apiToken}` },
  })
}

api.fetchTriggers = async (filters) => {
  const apiToken = localStorage.getItem('apiToken')
  //const query = { query: filters }
  return await axios.create({ baseURL: window.fmsApiLink }).post("triggers/fetch", filters, {
    headers: { Authorization: `Bearer ${apiToken}` },
  }).catch(e => console.log("catched error", e))
}

api.cancelTriggers = async (id) => {
  const apiToken = localStorage.getItem('apiToken')
  const res = await axios.create({ baseURL: window.fmsApiLink }).put("triggers/" + id, {processed: true} , {
    headers: { Authorization: `Bearer ${apiToken}`, }
  }).catch(e => console.log("catched error", e))
  return res
}

api.updateMap = async map => {
  const apiToken = localStorage.getItem('apiToken')
  // console.log("api updating fms map", map)
  const res = await axios.create({ baseURL: window.fmsApiLink }).put('map/' + map._id, map, { headers: { Authorization: `Bearer ${apiToken}`, } })
  return res
}



api.getRobotInfo = async robotName => {
  const apiToken = localStorage.getItem('apiToken')
   console.log("api token", apiToken, robotName)
  const res = await axios.create({ baseURL: window.fmsApiLink }).post('robots', { name: robotName }, { headers: { Authorization: `Bearer ${apiToken}`, } })
  console.log("fms robot info", res)
  return res
}

api.updateAreaMap = async (areaId, mapId) => {
  const apiToken = localStorage.getItem('apiToken')
  // console.log("updating area map", areaId, mapId)
  const res = await axios.create({ baseURL: window.fmsApiLink }).put('area/' + String(areaId), { mapId: mapId }, { headers: { Authorization: `Bearer ${apiToken}`, } })
  return res
}

api.getMap = async mapName => {
  const apiToken = localStorage.getItem('apiToken')
  // console.log("api getting map info", mapName)
  const res = await axios.create({ baseURL: window.fmsApiLink }).post('map/', { name: mapName }, { headers: { Authorization: `Bearer ${apiToken}`, } })
  return res
}

api.fetchMaps = async (query) => {
  let apiToken
  if (localStorage.getItem("apiToken")[0] !== '"') apiToken = localStorage.getItem("apiToken")
  else apiToken = localStorage.getItem('apiToken')
  return await axios.create({ baseURL: window.fmsApiLink }).post("map", query, {
    headers: { Authorization: `Bearer ${apiToken}` },
  }).catch(e => console.log("catched error", e))
}

api.fetchOrders = async (filters) => {
  const apiToken = localStorage.getItem('apiToken')
  const query = { query: filters, limit: 10 }
  // return await axios.create({ baseURL: window.fmsApiLink }).post("orders/fetch", query, {
  return await axios.create({ baseURL: window.fmsApiLink }).post("orders", query, {
    headers: { Authorization: `Bearer ${apiToken}` },
  }).catch(e => console.log("caught error", e))
}

api.cancelAllOrders = async () => {
  const apiToken = localStorage.getItem('apiToken')
  
  return await axios.create({ baseURL: window.fmsApiLink }).post("orders/cancel", {}, {
    headers: { Authorization: `Bearer ${apiToken}` },
  })
}

api.deleteTasks = async (mapId) => {
  const apiToken = localStorage.getItem('apiToken')
  return await axios.create({ baseURL: window.fmsApiLink }).delete("task/map/" + mapId, {
    headers: { Authorization: `Bearer ${apiToken}` },
  }).catch(e => console.log("catched error", e))
}

api.saveTask = async (task) => {
  const apiToken = localStorage.getItem('apiToken')
  return await axios.create({ baseURL: window.fmsApiLink }).post("task/new", task, {
    headers: { Authorization: `Bearer ${apiToken}` },
  }).catch(e => console.log("catched error", e))
}

api.fetchTasks = async (query) => {
  const apiToken = localStorage.getItem('apiToken')
  return await axios.create({ baseURL: window.fmsApiLink }).post("task", query, {
    headers: { Authorization: `Bearer ${apiToken}` },
  }).catch(e => console.log("catched error", e))
}

api.fetchAreas = async (query) => {
  const apiToken = localStorage.getItem('apiToken')
  return await axios.create({ baseURL: window.fmsApiLink }).post("area", query, {
    headers: { Authorization: `Bearer ${apiToken}` },
  }).catch(e => console.log("catched error", e))
}

api.findUsed = async (query) => {
  const apiToken = localStorage.getItem('apiToken')
  console.log("Token ", apiToken)
  return await axios.create({ baseURL: window.fmsApiLink }).post("used", query, {
    headers: { Authorization: `Bearer ${apiToken}` },
  })
}

api.updateUsed = async (query, type) => {
  const apiToken = localStorage.getItem('apiToken')
  console.log(query, type)
  return await axios.create({ baseURL: window.fmsApiLink }).post("/used/update/" + type, query, {
    headers: { Authorization: `Bearer ${apiToken}` },
  })
}

api.deleteUsed = async (type) => {
  const apiToken = localStorage.getItem('apiToken')

  return await axios.create({ baseURL: window.fmsApiLink }).delete("/used/delete/" + type, {
    headers: { Authorization: `Bearer ${apiToken}` },
  })
}

api.fetchOperation = async (id) => {
  const apiToken = localStorage.getItem('apiToken')
  const res = await axios.create({ baseURL: window.fmsApiLink }).post("operations/fetch", { _id: id }, {
    headers: { Authorization: `Bearer ${apiToken}` }
  }).catch(e => console.log("caught error", e))
  return res
}

api.getOperations = async () => {
  const apiToken = localStorage.getItem('apiToken')
  // const query = { query: filters, limit: 10 }
  const res = await axios.create({ baseURL: window.fmsApiLink }).post("operations", {}, {
    headers: { Authorization: `Bearer ${apiToken}`, }
  }).catch(e => console.log("caught error", e))
  return res
}

api.fetchRacks = async () => {
  const apiToken = localStorage.getItem('apiToken')

  const res = await axios.create({ baseURL: window.fmsApiLink }).post("rack", {}, {
    headers: { Authorization: `Bearer ${apiToken}` }
  }).catch(e => console.log("caught error", e))
  return res
}

api.updateOccupation = async (position, level, value) => {
  const apiToken = localStorage.getItem('apiToken')

  const res = await axios.create({ baseURL: window.fmsApiLink }).post("rack/occupation", { position, level, value }, {
    headers: { Authorization: `Bearer ${apiToken}` }
  }).catch(e => console.log("caught error", e))
  return res
}